import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';

import generateId from 'src/lib/generateId';

const useOnSaveRecipientCollection = ({ campaign, endDateEnabled }) => {
  const dispatch = useDispatch();
  return useCallback(
    ({ add, workingState, validate }) => {
      const startDateTime = getTimestampFromDatetime(workingState.startAfterDate, workingState.startAfterTime);
      const recipientCollection = { startAfter: startDateTime, campaignId: campaign.id, csvFile: workingState.csvFile };

      let endBeforeTime = '';
      if (endDateEnabled) {
        endBeforeTime = getTimestampFromDatetime(workingState.endBeforeDate, workingState.endBeforeTime);
        recipientCollection['endBefore'] = endBeforeTime;
      }

      const valueForValidation = {
        ...recipientCollection,
        ...(recipientCollection.csvFile ? { csvFile: { name: recipientCollection.csvFile?.name } } : {}),
      };
      if (!dispatch(validate(valueForValidation))) {
        return;
      }

      dispatch(
        add(
          { campaignId: campaign.id },
          { id: generateId(), recipientCollection: recipientCollection, csvFile: workingState.csvFile }
        )
      );
    },
    [campaign.id, endDateEnabled, dispatch]
  );
};

function getTimestampFromDatetime(date, time) {
  const dateMoment = moment(`${date} ${time}`, 'MM/DD/YYYY hh:mm');
  return dateMoment.toISOString();
}

export default useOnSaveRecipientCollection;
